<h4 class="fw-bold">
    {{ "breadcrumbs.attributes" | translate }}
    <span class="fw-light mx-1">
        @if (displayLabel) {
            - {{ displayLabel }}
        }
    </span>
</h4>

<div class="bg-card shadow rounded mb-3 p-3">
    <form class="col-12" [formGroup]="attributesForm">
        <div class="row">
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.nameAE' | translate"
                    formControlName="nameAE"
                    controlName="nameAE"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('nameAE')"
                />
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.nameEN' | translate"
                    formControlName="nameEN"
                    controlName="nameEN"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('nameEN')"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.descriptionAE' | translate"
                    formControlName="dscAE"
                    controlName="dscAE"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('dscAE')"
                />
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.descriptionEN' | translate"
                    formControlName="dscEN"
                    controlName="dscEN"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('dscEN')"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-dropdown
                    formControlName="dataType"
                    controlName="dataType"
                    [options]="dataTypeOptions()"
                    [label]="'attributes.create.data_type' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('dataType')"
                    [adaaSmartToolTips]="'attributes_tool_tip_data_type'"
                />
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-dropdown-multi
                    formControlName="attrItemTypes"
                    controlName="attrItemTypes"
                    [options]="itemTypeOptions()"
                    [label]="'attributes.create.item_type' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('attrItemTypes')"
                    [adaaSmartToolTips]="'attributes_tool_tip_limit'"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12 col-xs-12 d-flex justify-content-center">
                <adaa-form-checkbox
                    [label]="'add' | translate"
                    [checkboxMode]="'yesNo'"
                    controlName="available"
                    formControlName="available"
                    [adaaSmartToolTips]="'Add'"
                />
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12 d-flex justify-content-center">
                <adaa-form-checkbox
                    [label]="'common.form.label.mandatory' | translate"
                    [checkboxMode]="'yesNo'"
                    controlName="mandatory"
                    formControlName="mandatory"
                    (inputChanges)="setMandatory()"
                    [adaaSmartToolTips]="'attributes_tool_tip_mandatory'"
                />
            </div>
        </div>
    </form>
</div>

@if (showTable()) {
    <div class="mb-2">
        <adaa-data-table
            #adaaDataTable
            titleHeader="common.form.modals.title_list_of_values"
            [isLocalData]="true"
            [localData]="values()"
            [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.ATTR_TEXT_MAP_LIST"
            [itemTypeId]="Constants.CONSTANT_PERMISSIONS.EXTENDEND_ATTRIBUTES"
            [enableViewAction]="false"
            (addNewClicked)="valuesInput.pageMode = PageMode.create; valuesInput.open()"
            (actionClicked)="getAction($event)"
        />
    </div>
}

<adaa-form-action-buttons
    [showSaveButton]="pageMode() !== PageMode.view"
    [cancelButtonTitle]="pageMode() === PageMode.view ? 'common.form.button.close' : 'common.form.button.cancel'"
    (saveClicked)="save()"
    (cancelClicked)="cancel()"
/>

<adaa-attribute-values #valuesInput (submitValue)="addValue($event)" [selectedValue]="selectedValue()"></adaa-attribute-values>
<adaa-attributes-value-input
    #input
    [fieldType]="fieldType()"
    [dropdownData]="dropdownData()"
    [records]="records()"
    (defaultValue)="defaultValue.set($event); submit()"
></adaa-attributes-value-input>
